import PropTypes from "prop-types";
import { SortableTh } from "./sortable";
import { Table } from "reactstrap";

// Shared shell for the admin list tables: the wrap div, header (sortable or
// plain), body and loading spinner that were copy-pasted across every admin
// page. Rows must already be filtered + sorted by the caller.
//
// columns: [{ key, label, className, sortable, cell }]
//   - sortable → renders a SortableTh wired to sortKey/sortDir/onSort
//   - cell(row) → custom cell content; defaults to row[key]
// renderRow(row) → escape hatch to render the whole <tr> yourself (used when a
//   row needs its own state, e.g. a per-row modal); overrides `columns` cells.
export const AdminTable = ({
  columns,
  rows,
  loading,
  sortKey,
  sortDir,
  onSort,
  rowKey = (row) => row.id,
  onRowClick,
  renderRow,
}) => (
  <div className="admin-table-wrap">
    <Table className="admin-table align-middle">
      <thead>
        <tr>
          {columns.map((col) =>
            col.sortable ? (
              <SortableTh
                key={col.key}
                column={col.key}
                label={col.label}
                className={col.className}
                sortKey={sortKey}
                sortDir={sortDir}
                onSort={onSort}
              />
            ) : (
              <th key={col.key} className={col.className}>
                <span>{col.label}</span>
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {loading
          ? Array.from({ length: 8 }).map((_, index) => (
              <tr key={`skeleton-${index}`} className="admin-row--skeleton">
                {columns.map((col) => (
                  <td key={col.key}>
                    <span className="sk sk-line" />
                  </td>
                ))}
              </tr>
            ))
          : rows.map((row) =>
              renderRow ? (
                renderRow(row)
              ) : (
                <tr
                  key={rowKey(row)}
                  className={onRowClick ? "clickable-row" : undefined}
                  onClick={
                    onRowClick ? (event) => onRowClick(row, event) : undefined
                  }
                >
                  {columns.map((col) => (
                    <td key={col.key}>
                      {col.cell ? col.cell(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              )
            )}
      </tbody>
    </Table>
  </div>
);

AdminTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  sortKey: PropTypes.string,
  sortDir: PropTypes.string,
  onSort: PropTypes.func,
  rowKey: PropTypes.func,
  onRowClick: PropTypes.func,
  renderRow: PropTypes.func,
};
